import { toQuotedString, createIssuesUrl } from '@atlassian/jira-common-jql/src/helpers.tsx';

const getVersionPageUrl = (projectKey: string, versionId: string): string =>
	`/projects/${projectKey}/versions/${versionId}`;

const getVersionIssuesJql = (projectKey: string, versionName: string): string => {
	const jql = `project = ${toQuotedString(projectKey)} AND fixVersion = ${toQuotedString(
		versionName,
	)}`;
	return createIssuesUrl(jql);
};

export const getVersionIssuesUrl = (
	projectKey: string,
	isSoftwareProject: boolean,
	versionId: string,
	versionName: string,
): string => {
	if (isSoftwareProject) {
		return getVersionPageUrl(projectKey, versionId);
	}
	return getVersionIssuesJql(projectKey, versionName);
};
